const STYLES = {
  complete: "bg-emerald-950/60 text-emerald-400 border-emerald-800/50",
  in_progress: "bg-amber-950/60 text-amber-300 border-amber-800/50",
  pending: "bg-slate-800/70 text-slate-400 border-slate-700",
  overall: "bg-emerald-900/30 text-emerald-300 border-emerald-600/50",
};

const LABELS = { complete: "Complete", in_progress: "In Progress", pending: "Pending" };

export const StatusBadge = ({ state, label, testId }) => {
  const cls = STYLES[state] || STYLES.pending;
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 font-mono-ui text-[10px] uppercase tracking-[0.18em] ${cls}`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-80" />
      {label || LABELS[state]}
    </span>
  );
};
